import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { ChartOptions, ChartType, ChartDataset } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { Task } from 'src/app/models/Task';
import { AnalyticsTask } from 'src/app/models/AnalyticsTask';
import * as _ from 'underscore';
import { HelpersService } from 'src/app/services/shared/helpers.service';

@Component({
  selector: 'app-bar-chart-workers',
  templateUrl: './bar-chart-workers.component.html',
  styleUrls: ['./bar-chart-workers.component.css']
})
export class BarChartWorkersComponent implements OnInit {
  public barChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    // We use these empty structures as placeholders for dynamic theming.
    scales: {
      x: {
        ticks: {
          autoSkip: false,
          
        }
      }, y: {}
    },
    plugins: {
      datalabels: {
        display: false,
      }
    }
  };
  public barChartLabels: string[] = [];
  public barChartLabelsDuration: string[] = [];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [pluginDataLabels];
  public barChartColors: any[] = [{
    backgroundColor: 'coral',
    borderColor: 'coral',
    pointBackgroundColor: 'coral',
    pointBorderColor: '#fff',
    pointHoverBackgroundColor: '#fff',
  }
  ];
  public barChartColorsDuration: any[] = [{

    backgroundColor: 'orange',
    borderColor: 'orange',
    pointBackgroundColor: 'orange',
    pointBorderColor: '#fff',
    pointHoverBackgroundColor: '#fff',

  }
  ];
  public barChartData: ChartDataset[] = [];
  public barChartDataDuration: ChartDataset[] = [];
  @Input() dataset: Array<AnalyticsTask>;
  public workerNames = [];
  public mobile;
  constructor(public helpers: HelpersService) { }

  ngOnChanges(changes: SimpleChanges) {
    if ('dataset' in changes) {
      this.workerNames = [];
      if (this.dataset != undefined) {
        this.drawBarChart();
      }
    }
  }
  // events
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
  }

  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
  }

  ngOnInit() {

  }

  drawBarChart() {

    for (let i = 0; i < this.dataset.length; i++) {
      if (this.workerNames.length == 0) {
        this.workerNames.push(this.dataset[i].worker);
      } else {
        if (!this.workerNames.includes(this.dataset[i].worker)) {
          this.workerNames.push(this.dataset[i].worker);
        }
      }
    }

    let dataArray = [];
    let count = 0;
    for (let item of this.workerNames) {
      if (this.dataset != undefined) {
        for (let i = 0; i < this.dataset.length; i++) {
          if (this.dataset[i].worker === item) {
            count++;
          }
        }
        dataArray.push(count);

        count = 0;
      }
    }
    let outArrayOpravila = this.helpers.doGraphSorter(this.workerNames, dataArray);
    let outLabelsOpravila = [];
    let outValuesOpravila = [];
    for (let item of outArrayOpravila) {
      if (item.value > 0) {
        outLabelsOpravila.push(item.label);
        outValuesOpravila.push(item.value);
      }
    }

    this.barChartData = [{
      data: outValuesOpravila, label: 'Število opravil', backgroundColor: 'coral'
    }];
    this.barChartLabels = outLabelsOpravila;

    let dataArrayOfDuration = [];
    let sumDuration = 0;
    for (let item of this.workerNames) {
      if (this.dataset != undefined) {
        for (let i = 0; i < this.dataset.length; i++) {
          if (this.dataset[i].worker === item) {
            sumDuration += this.dataset[i].timespend;
          }
        }
        dataArrayOfDuration.push(sumDuration);

        sumDuration = 0;
      }
    }
    let outArray = this.helpers.doGraphSorter(this.workerNames, dataArrayOfDuration);
    let outLabels = [];
    let outValues = [];
    for (let item of outArray) {
      if (item.value > 0) {
        outLabels.push(item.label);
        outValues.push(item.value);
      }
    }

    this.barChartDataDuration = [{ data: outValues, label: 'Trajanje opravila v minutah', backgroundColor: 'coral' }];
    this.barChartLabelsDuration = outLabels;
  }
}
